module.exports = __webpack_public_path__ + "img/slider-5.07b9fea3.jpg";